/* =========================================================
   PRODUCT DETAILS — SKU / UPC per-variant sync.

   The Product Details metafield renders a static table whose SKU
   and UPC rows reflect only the product's default variant. This
   keeps those two rows in sync with the selected variant, matching
   the live site's behaviour.

   Hooks the theme's variant picker: assets/variant-picker.js
   dispatches a bubbling 'on:variant:change' CustomEvent whose
   detail.variant is the full variant object (includes .sku and
   .barcode). On first load we read the current variant straight
   from the picker's JSON so the initial state is correct too.

   Only the SKU and UPC rows are touched; every other Product
   Details row is left exactly as authored. A variant with no
   value (e.g. a sample with no barcode) hides that row rather
   than showing an empty cell.
   ========================================================= */
(function () {
  function findRow(label) {
    var tables = document.querySelectorAll('.llm-product-meta__table');
    for (var t = 0; t < tables.length; t++) {
      var rows = tables[t].querySelectorAll('tr');
      for (var r = 0; r < rows.length; r++) {
        var cells = rows[r].children;
        if (
          cells.length >= 2 &&
          cells[0].textContent.trim().toUpperCase() === label
        ) {
          return { row: rows[r], value: cells[1] };
        }
      }
    }
    return null;
  }

  function setField(label, value) {
    var found = findRow(label);
    if (!found) return;
    var hasValue = value != null && String(value).trim() !== '';
    if (hasValue) {
      found.value.textContent = value;
      found.row.style.display = '';
    } else {
      /* No value for this variant — hide the row instead of
         showing a blank/misleading cell. */
      found.row.style.display = 'none';
    }
  }

  /* VARIANT-LEVEL SPEC ROWS (2026-10-22). The fields-built Product Details table
     (snippets/llm-product-details-table.liquid) emits a JSON map
     { key: { variantId: value } } for every spec whose value differs by variant,
     and tags those rows data-spec-key. Variant-only long-tail rows carry
     data-llm-variant="<id>"; only the selected variant's are shown. An empty
     value hides the row, same rule as SKU/UPC above. */
  function updateSpecs(variant) {
    var tables = document.querySelectorAll('.llm-product-meta__table--fields');
    for (var t = 0; t < tables.length; t++) {
      var table = tables[t];
      var data = {};
      var blob = table.querySelector('script[data-llm-variant-specs]');
      if (blob) {
        try { data = JSON.parse(blob.textContent); } catch (e) { data = {}; }
      }
      var id = String(variant.id);
      for (var key in data) {
        var row = table.querySelector('tr[data-spec-key="' + key + '"]');
        if (!row || !row.children[1]) continue;
        var value = data[key][id];
        var hasValue = value != null && String(value).trim() !== '';
        if (hasValue) row.children[1].textContent = value;
        row.style.display = hasValue ? '' : 'none';
      }
      var extras = table.querySelectorAll('tr[data-llm-variant]');
      for (var i = 0; i < extras.length; i++) {
        extras[i].style.display = extras[i].getAttribute('data-llm-variant') === id ? '' : 'none';
      }
    }
  }

  function update(variant) {
    if (!variant) return;
    setField('SKU', variant.sku);
    setField('UPC', variant.barcode);
    updateSpecs(variant);
  }

  function currentVariantFromDom() {
    var scripts = document.querySelectorAll(
      'variant-picker [type="application/json"], script[type="application/json"]'
    );
    for (var i = 0; i < scripts.length; i++) {
      try {
        var j = JSON.parse(scripts[i].textContent);
        if (j && j.id && 'sku' in j && 'barcode' in j) return j;
      } catch (e) {
        /* not a variant blob */
      }
    }
    return null;
  }

  document.addEventListener('on:variant:change', function (e) {
    if (e.detail && e.detail.variant) update(e.detail.variant);
  });

  function init() {
    update(currentVariantFromDom());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
